import {
  LlamaProfile,
  LlamaGraduationCap,
  LlamaBuilding,
  LlamaLocation,
  LlamaDesktop,
  LlamaPaths,
  LlamaUsersMultiple,
  LlamaFile,
  LlamaSettings,
} from '@easyllama/ui-components/icons';

export const SEARCH_DEBOUNCE_MS = 250;
export const SKELETON_DELAY_MS = 200;
export const MIN_TERM_LENGTH = 1;
export const MAX_ROWS_PER_GROUP = 5;
export const MAX_VISIBLE_TYPE_PILLS = 4;

// Shared with the digit-key activation check, so the kbd hint never shows past what's reachable.
export const SHORTCUT_HOTKEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

export const SURFACE_TOKENS = {
  '--gs-surface-width': '960px',
  '--gs-surface-height': '610px',
  '--gs-surface-offset': '56px',
  '--gs-gutter': '18px',
  '--gs-input-height': '60px',
  '--gs-input-icon-size': '24px',
  '--gs-input-icon-gap': '36px',
  '--gs-footer-height': '42px',
  '--gs-pill-height': '32px',
  '--gs-row-radius': '6px',
  '--gs-row-padding-y': '9px',
  '--gs-group-icon': '17px',
  '--gs-medallion-icon': '19px',
  '--gs-input-font': '17px',
  '--gs-subtitle-font': '12.5px',
  '--gs-label-font': '11px',
  '--gs-label-tracking': '.09em',
  '--gs-transition': '140ms',
};

export const TYPE_ORDER = [
  'learners', 'trainings', 'classrooms', 'journeys', 'locations', 'groups', 'documents', 'kiosk',
];

export const TYPE_ICONS = {
  learners: LlamaProfile,
  trainings: LlamaGraduationCap,
  classrooms: LlamaBuilding,
  journeys: LlamaPaths,
  locations: LlamaLocation,
  groups: LlamaUsersMultiple,
  documents: LlamaFile,
  kiosk: LlamaDesktop,
};

// Companies::GlobalSearchPayload::ICONS names the model behind a shortcut, not its product label.
export const SHORTCUT_ICONS = {
  learners: LlamaProfile,
  training: LlamaGraduationCap,
  'my-training': LlamaBuilding,
  journeys: LlamaPaths,
  pin: LlamaLocation,
  'document-manager': LlamaFile,
  settings: LlamaSettings,
};

export const STATUS_BADGES = {
  // Same buckets LearnerSerializer#compliance_status_variant returns; labels match the design copy.
  learners: {
    complete: { color: 'success', label: 'Complete' },
    in_progress: { color: 'in-progress', label: 'In progress' },
    due: { color: 'critical', label: 'Past due' },
  },
  // Classroom.statuses enum (draft/running/completed/canceled); labels match the design copy.
  classrooms: {
    draft: { color: 'neutral', label: 'Draft' },
    running: { color: 'success', label: 'Active' },
    completed: { color: 'success', label: 'Completed' },
    canceled: { color: 'neutral', label: 'Canceled' },
  },
  // Training.statuses enum; the library calls a live course published.
  trainings: {
    live: { color: 'success', label: 'Published' },
    draft: { color: 'neutral', label: 'Draft' },
    archived: { color: 'neutral', label: 'Archived' },
  },
};
